/*
 * Copyright 2024 GLA UK Research and Development Directive
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './core/auth/auth-guard.service';

/**
 * The Application Routes.
 */
const routes: Routes = [
    {
        path: '',
        data: { help: { section: 'home' } },
        children: [{
            path: '',
            loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
        }, {
            path: 'home',
            canActivate: [AuthGuardService],
            loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
        }, {
            path: 'login',
            redirectTo: 'home',
            pathMatch: 'full',
        }]
    }, {
        path: 'messages',
        data: { help: { section: 'messages' } },
        loadChildren: () => import('./modules/messages/messages.module').then(m => m.MessagesModule)
    }, {
        path: 'atons',
        data: { help: { section: 'atons' } },
        loadChildren: () => import('./modules/atons/atons.module').then(m => m.AtonsModule)
    }, {
        path: 'editor',
        data: { help: { section: 'editor' } },
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/editor/editor.module').then(m => m.EditorModule)
    }, {
        path: 'admin',
        data: { help: { section: 'admin' } },
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
    }
];

/**
 * The Application Rooting Module.
 */
@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
